export default "__VITE_ASSET__583372f8__"